import { Command, HttpMethod } from "~/extensions/api";
export class FindTaikyoNotificationInfo extends Command {
    constructor() {
        super(HttpMethod.Post, "taikyonotification/find");
    }
    /** 入居契約No. */
    orgNyukyokeiyakuNoList = [];
    static create(OrgNyukyokeiyakuNoList) {
        let command = new FindTaikyoNotificationInfo();
        command.orgNyukyokeiyakuNoList = OrgNyukyokeiyakuNoList;
        return command;
    }
}
